import Vue from "vue";
import Router from "vue-router";
import General from "@/view/routes/General";
// import KIOSKDevice from "@/view/routes/KIOSKDevice";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    meta: {

                        title: 'Dashboard', // tab title
                        tabClass: 'custom-tab', // custom class, optional
                        closable: false, // is tab closable, defaults to `true`
                        key: 'path',
                    },
                    component: () => import("@/view/pages/Dashboard.vue")
                },
                {
                    name: "parents-meet",
                    path: "/parents-meet",
                    component: () => import("@/view/pages/parents-meet/Index")
                },
                {
                    path: "/unauthorized",
                    name: "unauthorized",
                    component: () => import("@/view/pages/error/unauthorized.vue")
                },
                {
                    name: "visitor",
                    path: "/visitor",
                    component: () => import("@/view/pages/visitor/Index")
                },
                {
                    name: "admit-card/qr-code",
                    path: "/admit-card/qr-code",
                    component: () => import("@/view/pages/admit-card/QrCode")
                },
                {
                    name: "admit-card/qr-code",
                    path: "/admit-card/qr-code",
                    component: () => import("@/view/pages/admit-card/QrCode")
                },
                {
                    name: "admit-card/upcoming-exams",
                    path: "/admit-card/upcoming-exams",
                    component: () => import("@/view/pages/admit-card/ExamList")
                },
                {
                    name: "gate-pass",
                    path: "/gate-pass",
                    component: () => import("@/view/pages/gate-pass/Index")
                },
                {
                    name: "entrance-exam-candidates",
                    path: "/entrance-exam/:examId/candidates",
                    component: () => import("@/view/pages/entrance-exam/Candidates")
                },
                {
                    path: "/unauthorized",
                    name: "unauthorized",
                    component: () => import("@/view/pages/error/unauthorized.vue")
                },
                {
                    path: "general-attendance",
                    name: "general-attendance",
                    meta: {

                        title: 'Check-in/out',
                        icon:'fas fa-school',
                        key: 'fullPath',
                        closable: true // is tab closable, defaults to `true`
                    },
                    component: () => import("@/view/pages/general-attendance/Index.vue")
                },
                ...General
            ]

        },
        {
            path: "/error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error-1",
                    name: "error-1",
                    component: () => import("@/view/pages/error/Error-1.vue")
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () => import("@/view/pages/error/Error-2.vue")
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue")
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () => import("@/view/pages/error/Error-4.vue")
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () => import("@/view/pages/error/Error-5.vue")
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () => import("@/view/pages/error/Error-6.vue")
                }
            ]
        },
        {
            path: "/",
            component: () => import("@/view/pages/auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/view/pages/auth/Login")
                },
                // {
                //     name: "register",
                //     path: "/register",
                //     component: () => import("@/view/pages/auth/Register")
                // },
                {
                    name: "verification",
                    path: "/verification",
                    component: () => import("@/view/pages/auth/Verification")
                },
                {
                    name: "forgot-password",
                    path: "/forgot-password",
                    component: () => import("@/view/pages/auth/ForgotPassword")
                },
                {
                    name: "reset-password",
                    path: "/reset-password",
                    component: () => import("@/view/pages/auth/ResetPassword")
                }
            ]
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        },

    ]
});
